import { useDefaultModuleActions } from "../../../common"
import { DynamoUserApi } from "../../../../services"
import { DataType, TableName } from "../../../../tables"
import { HoardOrder } from "../../state/types"
import { useDataTypeFileActions } from "../../../../features/data-types"
import { define } from "../../../../utils/typeUtils"

export const useCommonActions = () => {
    const defaultModuleActions = useDefaultModuleActions()
    const dataTypeFileActions = useDataTypeFileActions()

    return (companyId: string) => {
        const { count, save } = defaultModuleActions(DynamoUserApi, companyId)

        const countHoards = (propName: string, propValue: string) => {
            return count(TableName.HOARD_ORDERS, undefined, 1, { [propName]: propValue })
        }

        const saveHoard = (hoard: HoardOrder) => {
            return save(TableName.HOARD_ORDERS, hoard)
        }

        const saveHoardWithFile = async (
            hoard: HoardOrder,
            file: File,
            fileProp = 'invoiceUrl'
        ) => {
            const { saveWithFile } = dataTypeFileActions(define(companyId))
            return saveWithFile(TableName.HOARD_ORDERS, hoard, fileProp as keyof DataType, file)
        }

        return {
            countHoards,
            saveHoard,
            saveHoardWithFile
        }
    }
}
